/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  CreateDepartmentLocationRequest,
  DepartmentLocationApiResource,
  GetApiDepartmentLocationList200,
  GetApiDepartmentLocationListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse,
  UpdateDepartmentLocationRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiDepartmentLocationListResponse200 = {
  data: GetApiDepartmentLocationList200
  status: 200
}

export type getApiDepartmentLocationListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiDepartmentLocationListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiDepartmentLocationListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiDepartmentLocationListResponseSuccess = (getApiDepartmentLocationListResponse200) & {
  headers: Headers;
};
export type getApiDepartmentLocationListResponseError = (getApiDepartmentLocationListResponse400 | getApiDepartmentLocationListResponse401 | getApiDepartmentLocationListResponse403) & {
  headers: Headers;
};

export type getApiDepartmentLocationListResponse = (getApiDepartmentLocationListResponseSuccess | getApiDepartmentLocationListResponseError)

export const getGetApiDepartmentLocationListUrl = (params: GetApiDepartmentLocationListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/department-locations?${stringifiedParams}` : `/api/department-locations`
}

export const getApiDepartmentLocationList = async (params: GetApiDepartmentLocationListParams, options?: RequestInit): Promise<getApiDepartmentLocationListResponse> => {
  
  return customFetch<getApiDepartmentLocationListResponse>(getGetApiDepartmentLocationListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiDepartmentLocationCreateResponse201 = {
  data: DepartmentLocationApiResource
  status: 201
}

export type postApiDepartmentLocationCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiDepartmentLocationCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiDepartmentLocationCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiDepartmentLocationCreateResponseSuccess = (postApiDepartmentLocationCreateResponse201) & {
  headers: Headers;
};
export type postApiDepartmentLocationCreateResponseError = (postApiDepartmentLocationCreateResponse400 | postApiDepartmentLocationCreateResponse401 | postApiDepartmentLocationCreateResponse403) & {
  headers: Headers;
};

export type postApiDepartmentLocationCreateResponse = (postApiDepartmentLocationCreateResponseSuccess | postApiDepartmentLocationCreateResponseError)

export const getPostApiDepartmentLocationCreateUrl = () => {


  

  return `/api/department-locations`
}

export const postApiDepartmentLocationCreate = async (createDepartmentLocationRequest: CreateDepartmentLocationRequest, options?: RequestInit): Promise<postApiDepartmentLocationCreateResponse> => {
  
  return customFetch<postApiDepartmentLocationCreateResponse>(getPostApiDepartmentLocationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDepartmentLocationRequest,)
  }
);}


export type putApiDepartmentLocationUpdateResponse200 = {
  data: DepartmentLocationApiResource
  status: 200
}

export type putApiDepartmentLocationUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiDepartmentLocationUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiDepartmentLocationUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiDepartmentLocationUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiDepartmentLocationUpdateResponseSuccess = (putApiDepartmentLocationUpdateResponse200) & {
  headers: Headers;
};
export type putApiDepartmentLocationUpdateResponseError = (putApiDepartmentLocationUpdateResponse400 | putApiDepartmentLocationUpdateResponse401 | putApiDepartmentLocationUpdateResponse403 | putApiDepartmentLocationUpdateResponse404) & {
  headers: Headers;
};

export type putApiDepartmentLocationUpdateResponse = (putApiDepartmentLocationUpdateResponseSuccess | putApiDepartmentLocationUpdateResponseError)

export const getPutApiDepartmentLocationUpdateUrl = (id: number,) => {


  

  return `/api/department-locations/${id}`
}

export const putApiDepartmentLocationUpdate = async (id: number,
    updateDepartmentLocationRequest: UpdateDepartmentLocationRequest, options?: RequestInit): Promise<putApiDepartmentLocationUpdateResponse> => {
  
  return customFetch<putApiDepartmentLocationUpdateResponse>(getPutApiDepartmentLocationUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDepartmentLocationRequest,)
  }
);}


export type deleteApiDepartmentLocationDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiDepartmentLocationDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiDepartmentLocationDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiDepartmentLocationDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiDepartmentLocationDeleteResponseSuccess = (deleteApiDepartmentLocationDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiDepartmentLocationDeleteResponseError = (deleteApiDepartmentLocationDeleteResponse401 | deleteApiDepartmentLocationDeleteResponse403 | deleteApiDepartmentLocationDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiDepartmentLocationDeleteResponse = (deleteApiDepartmentLocationDeleteResponseSuccess | deleteApiDepartmentLocationDeleteResponseError)

export const getDeleteApiDepartmentLocationDeleteUrl = (id: number,) => {


  

  return `/api/department-locations/${id}`
}

export const deleteApiDepartmentLocationDelete = async (id: number, options?: RequestInit): Promise<deleteApiDepartmentLocationDeleteResponse> => {
  
  return customFetch<deleteApiDepartmentLocationDeleteResponse>(getDeleteApiDepartmentLocationDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


